export default __webpack_public_path__ + "static/how-its-work-e23f8006c2b4fa5f8192ae89fab24706.png";